import React from "react";

export default function BulletParagraph(title, content) {
  return (
    <div className="flex gap-[25px]">
      <div>
        <div className="mt-[4px] rounded-full w-[20px] h-[20px] xl:w-[28px] xl:h-[28px] bg-lightGray" />
      </div>
      <div className="flex flex-col gap-[10px] text-left whitespace-pre-line">
        <h1 className="text-[22px] xl:text-[28px] font-semibold">{title}</h1>
        <p className="text-[20px] xl:text-[24px] whitespace-pre-line">
          {content}
        </p>
      </div>
    </div>
  );
}
